// Core domain types for Errata — the Public Observatory

export type StatusThreat =
  | 'expertise'
  | 'belonging'
  | 'airtime'
  | 'valence'
  | 'repair'
  | 'silence'
  | 'other'

export type Uncertainty = 'speculative' | 'plausible' | 'evident'

export interface Impacts {
  perception: boolean
  choice: boolean
  coordination: boolean
}

export interface ObservationInput {
  momentText: string
  statusThreat: StatusThreat
  impacts: Impacts
  uncertainty: Uncertainty
  knownText: string
  unknownText: string
  evidenceNeed: string
  nextQuestion: string
}

export interface Observation {
  id: string
  createdAt: number
  moment: string
  threat: StatusThreat
  impacts: Impacts
  uncertainty: Uncertainty
  known: string | null
  unknown: string | null
  evidence: string | null
  nextQuestion: string | null
}

export interface EventMeta {
  id: string
  slug: string
  title: string
  context: string | null
  createdAt: number
  closesAt: number | null
  obsCount: number
  allowPublic?: number
  minObs?: number
  publishedAt?: number | null
  isClosed?: boolean
}

export interface Profile {
  event: EventMeta & { isPublic?: boolean }
  observations: Observation[]
}

export interface PublicErratum {
  slug: string
  title: string
  context: string | null
  obsCount: number
  publishedAt: number
  createdAt: number
}

export const THREAT_LABELS: Record<StatusThreat, string> = {
  expertise: 'Expertise / seniority signaling',
  belonging: 'Belonging / in-group legibility',
  airtime: 'Turn-taking & airtime legibility',
  valence: 'Outcome valence ambiguity',
  repair: 'Repair / face-saving opacity',
  silence: 'Interpreting silence or non-response',
  other: 'Other (hard to name)',
}

export const THREAT_SHORT: Record<StatusThreat, string> = {
  expertise: 'Expertise',
  belonging: 'Belonging',
  airtime: 'Airtime',
  valence: 'Valence',
  repair: 'Repair',
  silence: 'Silence',
  other: 'Other',
}

export const UNCERTAINTY_LABELS: Record<Uncertainty, string> = {
  speculative: 'Speculative — I might be projecting',
  plausible: 'Plausible — this seemed likely',
  evident: 'Evident — clearly felt by several',
}
